import { render, staticRenderFns } from "./SelectPersonal.vue?vue&type=template&id=f0a8d644&"
import script from "./SelectPersonal.vue?vue&type=script&lang=js&"
export * from "./SelectPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports